export const siteConfig = {
  brandName: "awmeadow",
  displayName: "AWMEADOW",
  brandLine: "EVERYDAY GOODS",
  logo: {
    type: "monogram",
    text: "AWMEADOW",
    subline: "EVERYDAY GOODS",
  },
  description:
    "Considered bags and accessories shaped by natural textures, useful details and everyday movement.",
  legalName: "HONG KONG FINDATA INTELLIGENCE INNOVATION LIMITED",
  currency: "EUR",
  locale: "en-IE",
  contact: {
    email: "focus@awmeadow.store",
    hours: "Monday–Friday, 09:00–18:00 CET",
    location: "UNIT 9,1/F,THE CLOUD,111 TUNG CHAU STREET,TAI KOK TSUI HK",
  },
  shipping: { standard: 4.95, freeThreshold: 200, returnDays: 14 },
  navigation: [
    { label: "Shop All", to: "/shop" },
    { label: "New in", to: "/shop?collection=New" },
    { label: "Purses", to: "/shop?search=pouch" },
    { label: "Accessories", to: "/shop?category=Accessories" },
    { label: "About", to: "/about" },
    { label: "Sale", to: "/shop?collection=Sale", accent: true },
  ],
};

const color = (name, hex) => ({ name, hex });
const black = color("Black", "#141414");

const rawProducts = [
  {
    id: 1,
    name: "Fern Hobo M",
    slug: "fern-hobo-m",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 149.5,
    compareAtPrice: 299,
    status: "sale",
    colors: [color("Ink Black", "#171717"), color("Oat", "#d8cbbb")],
    material: "Naturally grained sheepskin leather",
    dimensions: "24 × 34 × 16 cm",
    closure: "Magnetic flap closure",
    strap: "Detachable leather shoulder strap",
    description:
      "A relaxed medium hobo with softly structured seams and enough space for an unhurried day in the city.",
    tags: ["soft leather", "day bag", "editorial"],
    featured: true,
  },
  {
    id: 2,
    slug: "heritage-satchel-m",
    name: "Heritage Satchel M",
    category: "Handbags",
    type: "Satchel",
    price: 173.9,
    compareAtPrice: 249,
    status: "sale",
    colors: [color("Oxide Brown", "#6c4031"), black],
    material: "Washed cow leather",
    dimensions: "22 × 32 × 14 cm",
    closure: "Two-way zip closure",
    strap: "Twin handles and detachable crossbody strap",
    description:
      "An archive-inspired satchel with a gently worn finish, compact proportions and practical city-ready handles.",
    tags: ["archive", "top handle", "leather"],
    featured: true,
  },
  {
    id: 3,
    slug: "vale-hobo-m",
    name: "Vale Hobo M",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 269,
    status: "essential",
    colors: [color("Espresso", "#3e2b24"), color("Clay", "#a77964")],
    material: "Soft nappa leather",
    dimensions: "28 × 38 × 13 cm",
    closure: "Recessed zip closure",
    strap: "Wide adjustable shoulder strap",
    description:
      "A clean, generous hobo that folds naturally against the body and keeps its understated silhouette from morning to night.",
    tags: ["minimal", "soft bag", "everyday"],
    featured: true,
  },
  {
    id: 4,
    slug: "revival-satchel-m",
    name: "Revival Satchel M",
    category: "Handbags",
    type: "Satchel",
    price: 279,
    status: "new",
    colors: [color("Patent Black", "#101010"), color("Milk", "#ece6da")],
    material: "Crinkled patent leather",
    dimensions: "23 × 34 × 15 cm",
    closure: "Double zip closure",
    strap: "Rolled top handles and removable strap",
    description:
      "A polished revival of a familiar bowling shape, balanced by softly crinkled leather and functional side pockets.",
    tags: ["archive", "patent", "statement"],
    featured: true,
  },
  {
    id: 5,
    slug: "fold-satchel-s",
    name: "Fold Satchel S",
    category: "Handbags",
    type: "Satchel",
    price: 229,
    status: "new",
    colors: [color("Cherry", "#7b2024"), color("Graphite", "#333333")],
    material: "Smooth cow leather",
    dimensions: "19 × 25 × 11 cm",
    closure: "Fold-over magnetic closure",
    strap: "Short handle and detachable crossbody strap",
    description:
      "A crisp small bag inspired by a folded paper silhouette, with precise edges softened by supple leather.",
    tags: ["compact", "architectural", "top handle"],
  },
  {
    id: 6,
    slug: "nola-satchel-s",
    name: "Nola Satchel S",
    category: "Handbags",
    type: "Satchel",
    price: 139.93,
    compareAtPrice: 199.9,
    status: "sale",
    colors: [color("Warm Sand", "#c5a989"), black],
    material: "Pebbled cow leather",
    dimensions: "18 × 27 × 12 cm",
    closure: "Top zip closure",
    strap: "Two handles and adjustable shoulder strap",
    description:
      "A compact satchel with rounded corners and a practical interior, designed for hands-free days and quick transitions.",
    tags: ["small bag", "pebbled leather", "versatile"],
  },
  {
    id: 7,
    slug: "sable-crossbody-s",
    name: "Sable Crossbody S",
    category: "Crossbody Bags",
    type: "Crossbody",
    price: 199.9,
    status: "new",
    colors: [color("Leopard", "#9a7751"), black],
    material: "Hair-on leather with smooth leather trim",
    dimensions: "15 × 23 × 8 cm",
    closure: "Flap with magnetic closure",
    strap: "Slim adjustable crossbody strap",
    description:
      "A small crossbody with a restrained animal texture, framed by smooth leather for a sharp graphic finish.",
    tags: ["animal texture", "small", "evening"],
  },
  {
    id: 8,
    slug: "sable-hobo-m",
    name: "Sable Hobo M",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 279,
    status: "new",
    colors: [color("Leopard", "#9a7751"), color("Coal", "#282727")],
    material: "Hair-on leather with nappa leather sides",
    dimensions: "25 × 33 × 12 cm",
    closure: "Hidden magnetic closure",
    strap: "Curved leather shoulder handle",
    description:
      "A tactile medium hobo whose curved profile and subtle pattern bring energy to simple city uniforms.",
    tags: ["animal texture", "hobo", "statement"],
  },
  {
    id: 9,
    slug: "rowan-crossbody-m",
    name: "Rowan Crossbody M",
    category: "Crossbody Bags",
    type: "Crossbody",
    price: 107.94,
    compareAtPrice: 179.9,
    status: "sale",
    colors: [color("Forest", "#344a3f"), black],
    material: "Fine-grained cow leather",
    dimensions: "19 × 27 × 9 cm",
    closure: "Top zip closure",
    strap: "Adjustable webbing and leather strap",
    description:
      "A straightforward crossbody with a slim profile, softened edges and smart compartments for daily essentials.",
    tags: ["organized", "crossbody", "day bag"],
  },
  {
    id: 10,
    slug: "elowen-crossbody-s",
    name: "Elowen Crossbody S",
    category: "Crossbody Bags",
    type: "Crossbody",
    price: 119.94,
    compareAtPrice: 199.9,
    status: "sale",
    colors: [color("Bordeaux", "#652b35"), color("Mushroom", "#908174")],
    material: "Soft sheep leather",
    dimensions: "16 × 24 × 8 cm",
    closure: "Zip closure beneath folded edge",
    strap: "Detachable adjustable strap",
    description:
      "A soft small crossbody with a folded top line and just enough volume for the everyday edit.",
    tags: ["soft leather", "compact", "crossbody"],
  },
  {
    id: 11,
    slug: "meadow-shopper-l",
    name: "Meadow Shopper L",
    category: "Shoppers",
    type: "Shopper",
    price: 65.94,
    compareAtPrice: 109.9,
    status: "sale",
    colors: [color("Olive", "#68705b"), color("Stone", "#bcb4a6")],
    material: "Recycled technical canvas with leather trim",
    dimensions: "34 × 48 × 17 cm",
    closure: "Snap and drawcord closure",
    strap: "Long shoulder handles",
    description:
      "A light, roomy shopper that moves easily between market mornings, studio days and spontaneous weekends away.",
    tags: ["lightweight", "travel", "large"],
  },
  {
    id: 12,
    slug: "nova-crossbody-xs",
    name: "Nova Crossbody XS",
    category: "Crossbody Bags",
    type: "Crossbody",
    price: 59.94,
    compareAtPrice: 99.9,
    status: "sale",
    colors: [color("Silver", "#b5b7b8"), black],
    material: "Metallic finished leather",
    dimensions: "11 × 18 × 6 cm",
    closure: "All-around zip closure",
    strap: "Slim detachable strap",
    description:
      "A palm-sized crossbody with a softly metallic surface that carries a phone, cards and keys without bulk.",
    tags: ["mini", "metallic", "night"],
  },
  {
    id: 13,
    slug: "alder-tote-m",
    name: "Alder Tote M",
    category: "Shoppers",
    type: "Tote",
    price: 179.4,
    compareAtPrice: 299,
    status: "sale",
    colors: [color("Cognac", "#9b5f38"), color("Espresso", "#3a2922")],
    material: "Tumbled cow leather",
    dimensions: "29 × 39 × 15 cm",
    closure: "Inset zip closure",
    strap: "Long rolled shoulder handles",
    description:
      "An enduring leather tote with a generous opening and subtle base structure for workdays and city errands.",
    tags: ["work bag", "tote", "large"],
    featured: true,
  },
  {
    id: 14,
    slug: "arden-satchel-l",
    name: "Arden Satchel L",
    category: "Handbags",
    type: "Satchel",
    price: 290.9,
    compareAtPrice: 429,
    status: "sale",
    colors: [black, color("Chalk", "#dedbd3")],
    material: "Smooth premium cow leather",
    dimensions: "27 × 42 × 17 cm",
    closure: "Extended double zip closure",
    strap: "Sculpted top handles and removable strap",
    description:
      "A spacious, architectural satchel with an elongated zip and carefully balanced handles for polished everyday use.",
    tags: ["premium", "large", "structured"],
  },
  {
    id: 15,
    slug: "bramble-crossbody-m",
    name: "Bramble Crossbody M",
    category: "Crossbody Bags",
    type: "Crossbody",
    price: 74.9,
    compareAtPrice: 149.9,
    status: "sale",
    colors: [color("Dark Denim", "#32465e"), black],
    material: "Washed leather with canvas lining",
    dimensions: "20 × 28 × 10 cm",
    closure: "Curved zip closure",
    strap: "Adjustable leather strap",
    description:
      "A relaxed medium crossbody with curved seams and an easy washed finish that improves with daily wear.",
    tags: ["casual", "washed", "crossbody"],
  },
  {
    id: 16,
    slug: "dune-hobo-l",
    name: "Dune Hobo L",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 139.5,
    compareAtPrice: 279,
    status: "sale",
    colors: [color("Crocodile Brown", "#5b392b"), black],
    material: "Embossed cow leather",
    dimensions: "33 × 43 × 16 cm",
    closure: "Magnetic top closure",
    strap: "Broad single shoulder handle",
    description:
      "A roomy hobo with a low-key embossed surface, deep curved body and a comfortable wide handle.",
    tags: ["embossed", "large", "shoulder"],
  },
  {
    id: 17,
    slug: "wren-hobo-xs",
    name: "Wren Hobo XS",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 83.94,
    compareAtPrice: 139.9,
    status: "sale",
    colors: [color("Lavender Grey", "#97939c"), color("Ink", "#1c2025")],
    material: "Soft grained leather",
    dimensions: "14 × 22 × 8 cm",
    closure: "Zip closure",
    strap: "Short handle plus clip-on crossbody strap",
    description:
      "A miniature hobo with an expressive crescent line, scaled for the small things that matter after dark.",
    tags: ["mini", "crescent", "evening"],
  },
  {
    id: 18,
    slug: "nimbus-hobo-xs",
    name: "Nimbus Hobo XS",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 119.94,
    compareAtPrice: 199.9,
    status: "sale",
    colors: [color("Soft Blue", "#9aabb4"), color("Cream", "#e6dfd2")],
    material: "Padded nappa leather",
    dimensions: "15 × 24 × 9 cm",
    closure: "Concealed magnetic closure",
    strap: "Padded shoulder handle",
    description:
      "A soft, padded mini hobo with cloud-like volume and a quiet tonal finish for light everyday carry.",
    tags: ["padded", "mini", "soft"],
  },
  {
    id: 19,
    slug: "cedar-backpack",
    name: "Cedar Backpack",
    category: "Backpacks",
    type: "Backpack",
    price: 160.3,
    compareAtPrice: 229,
    status: "sale",
    colors: [black, color("Khaki", "#777160")],
    material: "Fine-grained leather",
    dimensions: "31 × 27 × 12 cm",
    closure: "Two-way zip closure",
    strap: "Adjustable leather backpack straps",
    description:
      "A compact leather backpack with a clear rectangular profile and considered pockets for weekday movement.",
    tags: ["hands-free", "work", "backpack"],
  },
  {
    id: 20,
    slug: "juniper-backpack-l",
    name: "Juniper Backpack L",
    category: "Backpacks",
    type: "Backpack",
    price: 230.3,
    compareAtPrice: 329,
    status: "sale",
    colors: [color("Mahogany", "#67453a"), black],
    material: "Tumbled cow leather",
    dimensions: "39 × 32 × 15 cm",
    closure: "Top zip closure",
    strap: "Padded adjustable leather straps",
    description:
      "A generous leather backpack with rounded shoulders, a broad opening and room for the working day.",
    tags: ["large", "commute", "backpack"],
  },
  {
    id: 21,
    slug: "indigo-hobo-m",
    name: "Indigo Hobo M",
    category: "Shoulder Bags",
    type: "Hobo",
    price: 183.2,
    compareAtPrice: 229,
    status: "sale",
    colors: [color("Washed Indigo", "#53697d"), color("Ecru", "#d8d1c2")],
    material: "Washed denim with leather trim",
    dimensions: "27 × 36 × 13 cm",
    closure: "Magnetic closure",
    strap: "Wide denim shoulder handle",
    description:
      "A denim hobo with washed tonal variation and soft volume, finished with precise leather details.",
    tags: ["denim", "seasonal", "soft"],
  },
  {
    id: 22,
    slug: "indigo-camera-bag-s",
    name: "Indigo Camera Bag S",
    category: "Crossbody Bags",
    type: "Camera Bag",
    price: 95.94,
    compareAtPrice: 159.9,
    status: "sale",
    colors: [color("Deep Indigo", "#34495b"), color("Stonewash", "#8796a0")],
    material: "Structured denim with leather trim",
    dimensions: "14 × 21 × 8 cm",
    closure: "Double zip closure",
    strap: "Adjustable webbing crossbody strap",
    description:
      "A compact camera bag that pairs precise construction with lived-in denim and an easy utility strap.",
    tags: ["denim", "camera bag", "compact"],
  },
  {
    id: 23,
    slug: "haven-tote-l",
    name: "Haven Tote L",
    category: "Shoppers",
    type: "Tote",
    price: 174.3,
    compareAtPrice: 249,
    status: "sale",
    colors: [black, color("Warm Grey", "#8b847d")],
    material: "Supple cow leather",
    dimensions: "31 × 45 × 16 cm",
    closure: "Zip-top closure",
    strap: "Long flat shoulder handles",
    description:
      "A wide, uncomplicated tote with a softened rectangular body and a spacious, organized interior.",
    tags: ["work bag", "tote", "spacious"],
  },
  {
    id: 24,
    slug: "zest-pouch-s",
    name: "Zest Pouch S",
    category: "Accessories",
    type: "Pouch",
    price: 41.93,
    compareAtPrice: 59.9,
    status: "sale",
    colors: [color("Lime", "#a7a96a"), black],
    material: "Grained leather",
    dimensions: "11 × 18 × 2 cm",
    closure: "Zip closure",
    strap: "Detachable leather wrist loop",
    description:
      "A slim leather pouch for cards, keys and small essentials, lifted by a clear seasonal color.",
    tags: ["small leather goods", "pouch", "gift"],
  },
];

const productData = rawProducts.map((item) => {
  const image = `/img/products/${String(item.id).padStart(2, "0")}-${
    item.slug
  }.png`;
  return {
    ...item,
    brand: siteConfig.displayName,
    image,
    images: [image],
    imageAlt: `${item.name} original studio product photograph`,
    size: ["One size"],
    colors: item.colors || [black],
    attributes: {
      material: item.material,
      dimensions: item.dimensions,
      closure: item.closure,
      strap: item.strap,
      lining: "Cotton blend lining",
      origin: "Designed by awmeadow",
    },
    features: [
      item.closure,
      item.strap,
      `${item.dimensions} (H × W × D)`,
      "Interior slip pocket and zipped compartment",
      "Protective dust bag included",
    ],
    tags: [...item.tags, item.type, item.status],
    rating: Number((4.6 + (item.id % 4) * 0.1).toFixed(1)),
    reviews: 18 + item.id * 3,
  };
});

export const productCategories = [
  "All",
  "Handbags",
  "Shoulder Bags",
  "Shoppers",
  "Crossbody Bags",
  "Backpacks",
  "Accessories",
];

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
  }).format(value);

export default productData;
